import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "truncate" }

import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'

import { useDropdownAnchor } from '@/composables/useDropdownAnchor'


export default {
  __name: 'NewFilterDropdown',
  props: ['name', 'filters'],
  emits: ['addFilter'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const { setReference, setFloating, floatingStyles } = useDropdownAnchor({ placement: 'bottom-end' })

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(Popover), {
    as: "div",
    class: "relative"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(PopoverButton), {
        ref: _unref(setReference),
        class: "inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-brand-500"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(props.name), 1),
          _createVNode(_unref(ChevronDownIcon), {
            class: "h-4 w-4 text-gray-500 shrink-0",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      }, 512),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(PopoverPanel), {
              ref: _unref(setFloating),
              style: _normalizeStyle(_unref(floatingStyles)),
              class: "z-50 overflow-y-auto rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none px-4 py-1"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.filters, (filter) => {
                  return (_openBlock(), _createBlock(_unref(PopoverButton), {
                    class: "text-sm font-medium sm:whitespace-nowrap text-gray-900 cursor-pointer my-3 block",
                    onClick: $event => (emit('addFilter', filter.value))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(filter.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 256)),
                (!props.filters.length)
                  ? (_openBlock(), _createBlock(_unref(PopoverButton), {
                      key: 0,
                      class: "text-sm font-medium sm:whitespace-nowrap text-gray-600 italic my-3 block"
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode(" No filters available ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        })
      ]))
    ]),
    _: 1
  }))
}
}

}